/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { ArchiveSport } from "./ArchiveSport";
import { toast } from "react-toastify";

const ListOfSports = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { AllSportsData, sportErrorMessage } = useAppSelector(state => state.sportList)
    const [archive, setArchive] = useState(false);
    const [deleteId, setDeleteId] = useState("")

    useEffect(() => {
        dispatch(AllSportsList(""))
    }, [])

    const Header = ['Sports Name', 'Created At', 'Updated At', 'Status']
    const accessor = ['name', 'createdAt', 'updatedAt', 'isActive']
    const columns = React.useMemo(
        () => Header.map((item, index) => ({
            Header: item,
            accessor: accessor[index],
        }
        )), [])
    if (sportErrorMessage) {
        toast.error(sportErrorMessage.message)
    }
    const handleAdd = () => {
        navigate("/add-sport")
    }

    const handleEdit = (id: string) => {
        navigate("/update-sport", { state: id })
    }

    const handleUserInfo = (id: string) => {
        navigate("/sport-info", { state: id })
    }

    const HandleDelete = (id: string) => {
        setArchive(true)
        setDeleteId(id)
    }

    return (
        <Card>
            <Card.Body className="pb-0">
                <div className="page-title align-items-center d-flex justify-content-between">
                    <Card.Title className="mb-0">Sports List</Card.Title>
                    <ButtonGroup>
                        <Button onClick={handleAdd} type="button" bname="Add Sport" name="add-sports" id="add-sports" className="btn btn-primary rounded-1"></Button>
                    </ButtonGroup>
                </div>
            </Card.Body>
            <Table columns={columns} data={AllSportsData} handleEdit={handleEdit} HandleShow={handleUserInfo} HandleDelete={HandleDelete} />
            <ArchiveSport setArchive={setArchive} archive={archive} id={deleteId} />
        </Card>
    )
}
export { ListOfSports }
